import React from "react";
import { Link } from "react-router-dom";

const PaginationColumn: React.FC<{ link?: string }> = ({ link, children }) => (
	<td>{link ? <Link to={link}>{children}</Link> : children}</td>
);

export default PaginationColumn;
